import { NgModule } from "@angular/core";
import { FormatRutDirective } from "./formatToRut.directive";
import { VerificacionRutValidatorDirective } from "./verifica-rut.directive";

@NgModule({
	declarations: [FormatRutDirective, VerificacionRutValidatorDirective],
	exports: [FormatRutDirective, VerificacionRutValidatorDirective],
})
export class RutModule {}
